<template>
   <v-row>
    <v-col cols="12" v-if="$store.state.accounts.retrieveLoader">
      <v-skeleton-loader class="mt-5" transition="fade-transition" type="table" />
    </v-col>
    <v-col cols="12" v-else>
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Banco</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-expansion-panels accordion tile flat>
            <v-expansion-panel v-for="(d, i) in banksList" :key="i">
              <v-expansion-panel-header disable-icon-rotate>
                <div class="d-flex">
                  <img :src="require(`@/assets/appAsset-bankingLogo__${d.bank.api_name}_Min.svg`)" alt="logo banco" width="32">
                  <div class="ml-5">
                    <span class="d-block body-2 text--secondary font-weight-medium">{{d.bank.name}}</span>
                    <span class="d-block body-2"><template v-if="d.name">{{d.name}}</template> <template v-if="d.number">{{d.number}}</template></span>
                  </div>
                </div>
                <template v-slot:actions>
                  <v-icon v-if="d.status === 'active'" color="primary">mdi-check</v-icon>
                  <v-icon v-else-if="d.status === 'authentication_failed'" color="red">mdi-alert-circle</v-icon>
                  <v-icon v-else-if="d.status === 'unknown_error'" color="amber">mdi-alert-circle</v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="pl-9">
                <v-row>
                  <v-col cols="6">
                    <v-list class="transparent">
                      <v-list-item>
                        <v-list-item-title>Nombre del titular</v-list-item-title>
                        <v-list-item-subtitle v-if="d.holder_name">{{d.holder_name}}</v-list-item-subtitle>
                        <v-list-item-subtitle class="font-italic text--disabled" v-else>No especificado</v-list-item-subtitle>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-title>Identificación del titular</v-list-item-title>
                        <v-list-item-subtitle v-if="d.holder_id">{{d.holder_id}}</v-list-item-subtitle>
                        <v-list-item-subtitle class="font-italic text--disabled" v-else>No especificado</v-list-item-subtitle>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-title>ID</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-tooltip right transition="scale-transition">
                            <template v-slot:activator="{on}">
                              <v-btn class="font-weight-regular" @click="toClipboard(d.id)" text color="secondary" v-on="on" :ripple="false">{{d.id}}</v-btn>
                            </template>
                            <span>Copiar</span>
                          </v-tooltip>
                        </v-list-item-subtitle>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-title>Conectado desde</v-list-item-title>
                        <v-list-item-subtitle>{{d.created | dateTime}}</v-list-item-subtitle>
                      </v-list-item>
                      <v-list-item class="mt-4">
                        <v-list-item-content>
                          <v-btn @click="deleteBank(i)" dark small color="red">Desconectar cuenta</v-btn>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-col>
                  <v-col cols="6">
                    <v-list class="transparent">
                      <v-list-item>
                        <v-list-item-title>Estado de la conexión</v-list-item-title>
                        <v-list-item-subtitle>
                          <template v-if="d.status === 'active'">
                            <v-chip class="my-2" color="lightBlue" text-color="primary" small>Conectado<v-icon class="ml-1" x-small>mdi-check</v-icon></v-chip>
                          </template>
                          <template v-if="d.status === 'authentication_failed'">
                            <v-chip class="my-2" color="red lighten-5" text-color="red" small>Contraseña incorrecta</v-chip>
                          </template>
                          <template v-if="d.status === 'unknown_error'">
                            <v-chip class="my-2" color="amber lighten-5" text-color="amber accent-4" small>Última conexión fallida</v-chip>
                          </template>
                        </v-list-item-subtitle>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-title>Última sincronización</v-list-item-title>
                        <v-list-item-subtitle v-if="d.last_sync">{{d.last_sync | dateTime}}</v-list-item-subtitle>
                        <v-list-item-subtitle class="font-italic text--disabled" v-else>Aún no se sincroniza</v-list-item-subtitle>
                      </v-list-item>
                    </v-list>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
              <v-divider />
            </v-expansion-panel>
          </v-expansion-panels>
          <v-row v-if="!banksList.length" class="mx-0 py-5" aling="center" justify="center">
            <v-col class="py-2 text-center" cols="6">
              <v-icon class="my-1 d-block" color="secondary" size="40">mdi-bank</v-icon>
              <span class="my-1 d-block subtitle-1 font-weight-medium">Transferencias asociadas a los pagos de clientes (sin esfuerzo)</span>
              <span class="my-1 px-8 d-block body-2">Conecta tu cuenta de banco y haz match entre cada transferencia recibida y los pagos de clientes.</span>
            </v-col>
          </v-row>
          <v-row class="mx-0">
            <v-col>
              <v-card outlined>
                <v-card-text class="pa-0">
                  <v-row class="mx-0">
                    <v-col cols="3">
                      <span class="d-block subtitle-2 font-weight-medium">Cuenta de banco conectada</span>
                    </v-col>
                    <v-col cols="6">
                      <span class="d-block body-2"><span class="font-weight-medium">18.00 USD o 0,5 UF + IVA</span> / mensual por cuenta activa</span>
                      <span class="d-block body-2 text--primary">Adicionales al cobro mensual por uso de Piriod</span>
                    </v-col>
                    <v-col cols="3" class="text-right">
                      <v-btn class="my-1" @click="initFintocWidget" color="primary">Conectar banco</v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import GenericViewMixin from '@/mixins/GenericViewMixin'

export default {
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    widgetFintoc: null
  }),
  computed: mapState({
    banksCount: state => state.accounts.banksCount,
    banksList: state => state.accounts.banksList
  }),
  created () {
    this.getList()

    // add fintoc script
    window.addEventListener('load', () => {
      const s = window.document.createElement('script')
      s.src = 'https://js.fintoc.com/v1/'

      window.document.head.appendChild(s)
    })
  },
  methods: {
    getList () {
      this.$store.dispatch('accounts/LIST', {
        resource: 'banks',
        query: {
          status__in: 'active,authentication_failed,unknown_error'
        }
      })
    },
    deleteBank (i) {
      this.$dialog.warning({
        title: 'Desconectar cuenta',
        text: `
          <span class="d-block mb-4">Al desconectar la cuenta:</span>
          <span class="d-block pl-6">1. No se seguirán importando los movimientos de esta</span>
          <span class="d-block pl-6">2. Los movimientos ya importados seguirán disponibles</span>
          <span class="d-block my-4">¿Estás seguro de continuar?</span>
          <span class="d-block font-weight-medium">Esta acción no se puede deshacer</span>
        `,
        actions: [
          {
            color: 'red',
            text: 'Continuar',
            handle: () => {
              this.$store.dispatch('accounts/DESTROY', {
                resource: 'banks',
                id: this.banksList[i].id
              })
              .then(() => {
                this.$dialog.message.info('La cuenta de banco ha sido desconectada')
              })
              .catch((error) => {
                this.$dialog.message.error(this.parseErrors(error.response.data))
              })
            }
          }
        ]
      })
    },
    initFintocWidget () {
      if (!this.widgetFintoc) {
        this.widgetFintoc = window.Fintoc.create({
          holderType: 'business',
          product: 'movements',
          publicKey: this.$FINTOC_API_KEY,
          // webhookUrl: `${this.$API_BASE}/banks/?provider=fintoc&external=True&account=${this.account.id}`
          webhookUrl: `https://api.piriod.com/banks/?provider=fintoc&external=True&account=${this.account.id}`,
          onSuccess: this.getList
        })
      }

      this.widgetFintoc.open()
    }
  }
}
</script>